<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Download">
  <!-- pdf -->
  <div class="card border-0 p-0 rounded-4 download-card">
    <div class="card-details-div">
      <img
        [src]="worksheetItem.Image | contentImage: '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
        class="download-image"
      />
      <div class="card-body d-flex flex-column justify-content-between bg-secondary">
        <p class="text-start title-text text-white font-size-14">{{ worksheetItem.Title }}</p>
        <div class="btn btn-download rounded-4 mx-auto" (click)="getDownload(worksheetId, worksheetItem.Id)" target="_blank">
          <span class="font-size-14 fw-bold text-start header-title text-white text-capitalize">{{
            'gallery.download' | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Gallery">
  <!-- image -->
  <div class="card border-0 p-0 gallery">
    <div (click)="openGalleryImage(galleryImage)" class="cursor-pointer">
      <img
        [src]="worksheetItem.Image | contentImage: '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>
  </div>
  <ng-template #galleryImage let-modal>
    <div class="modal-body">
      <button type="button" class="btn-close-modal" (click)="modal.dismiss()">
        <span class="icon material-icons">cancel</span>
      </button>
      <img
        [src]="worksheetItem.Image | contentImage: '6' : 'marketplace'"
        class="modal-image rounded-0"
        [alt]="worksheetItem.Title"
        [@zoomAnimation]
      />
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.ProviderVideo">
  <!-- video -->
  <div class="card border-0 p-0 player-container rounded-0">
    <div [ngSwitch]="worksheetItem.ProviderId" class="w-100 h-100">
      <ng-container *ngSwitchCase="providerName.Facebook">
        <fgb-facebook-player [streamKey]="worksheetItem.ProviderKey"></fgb-facebook-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.YouTube">
        <fgb-youtube-player [streamKey]="worksheetItem.ProviderKey"></fgb-youtube-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.StreamingVideoProvider">
        <fgb-svp-player [streamKey]="worksheetItem.ProviderKey"></fgb-svp-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Twitch">
        <fgb-twitch-player [streamKey]="worksheetItem.ProviderKey"></fgb-twitch-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Viemo">
        <fgb-vimeo-player [streamKey]="worksheetItem.ProviderKey"></fgb-vimeo-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Boxcast">
        <fgb-boxcast-player [streamKey]="worksheetItem.ProviderKey"></fgb-boxcast-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Streamable">
        <fgb-streamable-player [streamKey]="worksheetItem.ProviderKey"></fgb-streamable-player>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType == worksheetType.Link">
  <!-- link -->
  <div class="card border-0 p-0">
    <div class="card-details-div">
      <img
        [src]="worksheetItem.Image | contentImage: '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>
    <a target="_blank" [href]="worksheetItem.LinkUrl" class="btn btn-primary bg-primary text-description border-0 fw-bold">
      {{ worksheetItem.Description }}
    </a>
  </div>
</ng-container>
